<template>
  <div class="card-content">
    <form @submit.prevent="buscar">
      <!-- Campos de filtro -->
      <div class="columns is-multiline is-variable is-1-mobile">
        <!-- Nome -->
        <div class="column is-full-mobile is-half--desktop">
          <div class="field">
            <label class="label">Nome</label>
            <b-input
              v-model="filtro.nome"
              placeholder="Digite o Nome"
              @input="atualizarBusca"
            />
          </div>
        </div>
        <!-- CPF -->
        <div class="column is-full-mobile is-half-desktop">
          <div class="field">
            <label class="label">CPF</label>
            <b-input
              v-model="filtro.cpf"
              placeholder="Digite o CPF"
              @input="atualizarBusca"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "FilterPerson",
  props: {
    initialFiltro: {
      type: Object,
      default: () => ({
        nome: null,
        cpf: null,
      }),
    },
  },
  data() {
    return {
      filtro: { ...this.initialFiltro },
      timer: null,
    };
  },
  methods: {
    atualizarBusca() {
      clearTimeout(this.timer); // Evita múltiplas execuções seguidas
      this.timer = setTimeout(() => {
        this.buscar();
      }, 500);
    },
    buscar() {
      this.$emit("filtrar", this.filtro);
    }
  },
};
</script>
